<app-nav></app-nav>
  <section class="aboutUs">
    <div class="container">
      <div class="page_progress">
        <h5 class="comments_dash">Comments</h5>
        <ul class="StepProgress">
         
        
          <li class="hand"> <strong>{{Acknowledged}}</strong>       
            <ul class="ll1">
              <li class="StepProgress-item1"><b>Claim Number :- {{AcknowledgedByinsurer}}</b>
              </li>
            </ul>
                
</li>
        
        </ul>

        </div>
    </div>
  </section>

  <div id="spinner" [hidden]="!loading">
    <div class="spinnerfull">
      <i class="fa fa-spinner fa-spin fa-3x"></i>
    </div>
  </div>